import { getMessages } from '../../../../../../../store/constants';

export const SNACKBAR_RECURRING_CREATED = getMessages().getText('snackbar.recurring.created');
export const SNACKBAR_ID_RECURRING_CREATED = 'SNACKBAR_ID_RECURRING_CREATED';
